import React, { Component, Fragment } from 'react';

import Moment from 'react-moment';
import { connect } from "react-redux";
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GroupIcon from '@mui/icons-material/Group';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';


 
class DisplayMoreRecordInfo extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          showrecordinfo: false
        }

      }




      handleopencloserecordinfo= (e) => {
        this.setState(prevState => ({
            showrecordinfo: !prevState.showrecordinfo
        }));
      } 
      
      split_participans(participants) {
        let participantssplit = "";
        let participantshtml = "";
        if (participants !== null){
          participantssplit = participants.split(";");
        }
     
      
       const participantssplitclean = participantssplit.map(element => {
        return element.trim();
       });

       const participantssplitcleaempty = participantssplitclean.map(element => {
           if (element !== ""){
            return element;
           }
       });

       participantshtml += participantssplitcleaempty + " ";
     return (participantshtml)
      } 


    render () {  

        const recorddata = this.props.recordinfo

        //console.log(this.state)
        //console.log(this.props)
       
        let participants = this.props.recordinfo.participants;
        let participantout = this.split_participans(participants) 
        
        
        return (
            <Fragment>
                {this.state.showrecordinfo &&
                <Fragment>
                    <p className="logtext">
                    <AccountBalanceIcon /> <strong>{recorddata.account.name}</strong> | {recorddata.account.description}<br />
                    <MeetingRoomIcon /> {recorddata.hostDisplayName} | {recorddata.hostEmail}<br />
                    <GroupIcon /> {participantout}<br />
                    <AccessTimeIcon /> von <strong><Moment format="DD.MM.YYYY, HH:mm">{recorddata.start}</Moment></strong> bis <strong><Moment format="DD.MM.YYYY, HH:mm">{recorddata.end}</Moment></strong> | {recorddata.timezone} <br />
                    <Grid3x3Icon /> <em>{recorddata.meetingId}</em>
                    </p>
                    
                 <hr />
                    <Chip 
                        label="Record Details ausblenden"
                        onClick={this.handleopencloserecordinfo}
                        variant="outlined"
                        icon={<CloseIcon />} 
                    />  
                </Fragment>
                }
               
                {!this.state.showrecordinfo && recorddata !== null &&
                <Fragment>
               
                <Chip 
                label="Record Details ansehen"
                onClick={this.handleopencloserecordinfo}
                variant="outlined"
                icon={<VisibilityIcon />}   
                /> 
               </Fragment>    
                }
            </Fragment>
          
        )
    }
}

const mapStateToProps = state => ({
  state: state,
  admintenants: state.getuserdata.admintenants
});



export default connect(mapStateToProps)(DisplayMoreRecordInfo);
